import React from "react";
import { Box, Typography, Grid, Divider } from "@mui/material";
import { Irai, MasterItem } from "../types/GxpTypes";
import { translateFieldName } from "../forms/IraiRegisterSubForm";

/**
 * マスターデータからフィールド値の表示テキストを取得する
 * @param key - フィールド名
 * @param value - フィールドの値
 * @param getMaster - マスターデータ取得関数
 * @returns 表示用テキスト
 */
export const getInputText = (
  key: string,
  value: string | number | Date | null,
  getMaster: (fieldName: keyof Irai) => MasterItem[]
): string => {
  const master = getMaster(key as keyof Irai);
  switch (key) {
    case "patientGender":
    case "diagnosisId":
    case "lymphStsId":
    case "esStsId":
    case "prStsId":
    case "her2StsId":
    case "tclass":
    case "nclass":
    case "mclass":
    case "menstruation":
    case "tumorGrade":
    case "biopsyId":
      return master.find((item) => item.id === value)?.name ?? "";
    default:
      return value ? value.toString() : "";
  }
};

type RenderColumnProps = {
  entries: [string, string | number | Date | null][];
  getMaster: (fieldName: keyof Irai) => MasterItem[];
};

/**
 * 2列レイアウト用のカラムをレンダリングする
 * @param entries - 表示するキーと値のペア配列
 * @param getMaster - マスターデータ取得関数
 * @returns レンダリングされたカラム
 */
export const RenderColumn: React.FC<RenderColumnProps> = ({ entries, getMaster }) => (
  <Box sx={{ bgcolor: 'background.paper', borderRadius: 1, p: 2 }}>
    {entries.map(([key, value], index) => (
      <React.Fragment key={key}>
        <Grid container spacing={1} sx={{ py: 1 }}>
          <Grid item xs={5}>
            <Typography
              variant="subtitle2"
              sx={{ fontWeight: "bold", fontSize: "0.875rem", color: 'text.secondary' }}
            >
              {translateFieldName(key)}
            </Typography>
          </Grid>
          <Grid item xs={7}>
            <Typography variant="body2" sx={{ fontSize: "0.875rem" }}>
              {getInputText(key, value, getMaster)}
            </Typography>
          </Grid>
        </Grid>
        {index < entries.length - 1 && (
          <Divider sx={{ my: 0.5 }} />
        )}
      </React.Fragment>
    ))}
  </Box>
);
